export default "__VITE_ASSET__DcfGZQIN__"